"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const IAnalytics_1 = require("../interfaces/IAnalytics");
const IOrderType_1 = require("../interfaces/IOrderType");
// import { OrderStateEnum } from "../interfaces/IOrderState";
const Time = __importStar(require("@sellout/utils/.dist/time"));
const Price = __importStar(require("@sellout/utils/.dist/price"));
const moment = __importStar(require("moment-timezone"));
const sum = (array) => (array.length ? array.pop() + sum(array) : 0);
const makeArray = (intervalNum) => new Array(intervalNum).fill(0);
const makeCoordinates = (orders, intervalInfo, sumFn) => {
    const { startDate, intervalLength, intervalNum, interval } = intervalInfo;
    const coordinates = makeArray(intervalNum).map((_, index) => {
        // set x to beginning second of interval
        let x;
        switch (interval) {
            case IAnalytics_1.AnalyticsIntervalEnum.Hour:
                x = Time.getStartOfHour(index * intervalLength + startDate);
                break;
            case IAnalytics_1.AnalyticsIntervalEnum.Day:
                x = Time.getStartOfDay(index * intervalLength + startDate);
                break;
            case IAnalytics_1.AnalyticsIntervalEnum.Week:
                x = Time.getStartOfWeek(index * intervalLength + startDate);
                break;
            case IAnalytics_1.AnalyticsIntervalEnum.Month:
                x = Time.getStartOfMonth(index * intervalLength + startDate);
                break;
            case IAnalytics_1.AnalyticsIntervalEnum.Year:
                x = Time.getStartOfYear(index * intervalLength + startDate);
                break;
            default:
                x = Time.getStartOfDay(index * intervalLength + startDate);
                break;
        }
        const filteredOrder = orders
            .filter((order) => {
            const createdAt = order.createdAt;
            return x <= createdAt && createdAt < x + intervalLength;
        });
        const y = sumFn(filteredOrder);
        return {
            x,
            y,
        };
    });
    // quick solution to remove duplicated coordinates
    // real issue is probably above..
    const uniqueCoords = Array.from(new Set(coordinates.map(a => a.x)))
        .map(x => {
        return coordinates.find(a => a.x === x);
    });
    return uniqueCoords;
};
const makeAnalytics = (type, orders, intervalInfo, valueType, coordinatesSumFn, segmentTypes, segmentCoordinatesHOSumFn) => {
    var _a;
    const { interval, intervalOptions } = intervalInfo;
    const segments = (_a = segmentTypes === null || segmentTypes === void 0 ? void 0 : segmentTypes.map((segmentType) => {
        const coordinates = segmentCoordinatesHOSumFn
            ? makeCoordinates(orders, intervalInfo, segmentCoordinatesHOSumFn(segmentType))
            : [];
        const segment = {
            label: segmentType,
            interval: interval,
            intervalOptions: intervalOptions,
            coordinates,
            segments: [],
            type: valueType,
        };
        return segment;
    })) !== null && _a !== void 0 ? _a : [];
    const coordinates = makeCoordinates(orders, intervalInfo, coordinatesSumFn);
    const analytics = {
        label: type,
        interval: interval,
        intervalOptions: intervalOptions,
        coordinates,
        segments,
        type: valueType,
    };
    return analytics;
};
const MAX_INTERVALS = 60;
const intervalMap = {
    [IAnalytics_1.AnalyticsIntervalEnum.Hour]: 60 * 60,
    [IAnalytics_1.AnalyticsIntervalEnum.Day]: 60 * 60 * 24,
    [IAnalytics_1.AnalyticsIntervalEnum.Week]: 60 * 60 * 24 * 7,
    [IAnalytics_1.AnalyticsIntervalEnum.Month]: 60 * 60 * 24 * 30,
    [IAnalytics_1.AnalyticsIntervalEnum.Year]: 60 * 60 * 24 * 365,
};
const intervalsMap = {
    [IAnalytics_1.AnalyticsIntervalEnum.Hour]: [IAnalytics_1.AnalyticsIntervalEnum.Hour, IAnalytics_1.AnalyticsIntervalEnum.Day],
    [IAnalytics_1.AnalyticsIntervalEnum.Day]: [IAnalytics_1.AnalyticsIntervalEnum.Day, IAnalytics_1.AnalyticsIntervalEnum.Week],
    [IAnalytics_1.AnalyticsIntervalEnum.Week]: [IAnalytics_1.AnalyticsIntervalEnum.Week, IAnalytics_1.AnalyticsIntervalEnum.Month],
    [IAnalytics_1.AnalyticsIntervalEnum.Month]: [IAnalytics_1.AnalyticsIntervalEnum.Month, IAnalytics_1.AnalyticsIntervalEnum.Year],
    [IAnalytics_1.AnalyticsIntervalEnum.Year]: [IAnalytics_1.AnalyticsIntervalEnum.Year],
};
const maxDuration = (interval) => {
    return intervalMap[interval] * MAX_INTERVALS;
};
const getIntervalFromDuration = (duration) => {
    const maxHour = maxDuration(IAnalytics_1.AnalyticsIntervalEnum.Hour);
    const maxDay = maxDuration(IAnalytics_1.AnalyticsIntervalEnum.Day);
    const maxWeek = maxDuration(IAnalytics_1.AnalyticsIntervalEnum.Week);
    const maxMonth = maxDuration(IAnalytics_1.AnalyticsIntervalEnum.Month);
    if (duration <= maxHour) {
        return IAnalytics_1.AnalyticsIntervalEnum.Hour;
    }
    else if (duration <= maxDay) {
        return IAnalytics_1.AnalyticsIntervalEnum.Day;
    }
    else if (duration <= maxWeek) {
        return IAnalytics_1.AnalyticsIntervalEnum.Week;
    }
    else if (duration <= maxMonth) {
        return IAnalytics_1.AnalyticsIntervalEnum.Month;
    }
    else {
        return IAnalytics_1.AnalyticsIntervalEnum.Year;
    }
};
const getIntervalInfo = (orders, startDate, endDate, interval) => {
    var _a, _b;
    startDate = startDate || ((_a = orders[orders.length - 1]) === null || _a === void 0 ? void 0 : _a.createdAt) || Time.getStartOfCurrentDay();
    endDate = endDate || ((_b = orders[0]) === null || _b === void 0 ? void 0 : _b.createdAt) || Time.getEndOfCurrentDay();
    if (startDate === endDate) {
        endDate = Time.getEndOfCurrentDay();
    }
    const duration = endDate - startDate; // duration in seconds
    const intervalFromDuration = getIntervalFromDuration(duration);
    const intervalOptions = intervalsMap[intervalFromDuration];
    if (!interval) {
        interval = getIntervalFromDuration(duration);
    }
    if (!intervalOptions.includes(interval)) {
        interval = intervalOptions[0];
    }
    // Time length in seconds that each interval consists of.
    const intervalLength = intervalMap[interval];
    // Number of intervals.
    const intervalNum = Math.ceil(duration / intervalLength) + 1;
    return {
        startDate,
        endDate,
        duration,
        interval,
        intervalOptions,
        intervalLength,
        intervalNum,
    };
};
exports.default = {
    fromOrders(type, orders, showSegments, startDate, endDate, interval) {
        const intervalInfo = getIntervalInfo(orders, startDate, endDate, interval);
        switch (type) {
            case IAnalytics_1.AnalyticsTypeEnum.Overview:
                return this.overview(type, orders, intervalInfo);
            case IAnalytics_1.AnalyticsTypeEnum.TotalSales:
                return this.totalSales(type, orders, intervalInfo, showSegments);
            case IAnalytics_1.AnalyticsTypeEnum.TicketSales:
                return this.ticketSales(type, orders, intervalInfo, showSegments);
            case IAnalytics_1.AnalyticsTypeEnum.TicketsSold:
                return this.ticketsSold(type, orders, intervalInfo, showSegments);
            case IAnalytics_1.AnalyticsTypeEnum.TicketComps:
                return this.ticketComps(type, orders, intervalInfo, showSegments);
            case IAnalytics_1.AnalyticsTypeEnum.UpgradeSales:
                return this.upgradeSales(type, orders, intervalInfo, showSegments);
            case IAnalytics_1.AnalyticsTypeEnum.UpgradesSold:
                return this.upgradesSold(type, orders, intervalInfo, showSegments);
            case IAnalytics_1.AnalyticsTypeEnum.TicketComps:
                return this.ticketComps(type, orders, intervalInfo, showSegments);
            case IAnalytics_1.AnalyticsTypeEnum.Promotions:
                return this.promotions(type, orders, intervalInfo, showSegments);
            case IAnalytics_1.AnalyticsTypeEnum.TotalOrders:
                return this.totalOrders(type, orders, intervalInfo);
            case IAnalytics_1.AnalyticsTypeEnum.EventAnalytics:
                return this.eventAnalytics(type, orders, intervalInfo, showSegments);
            case IAnalytics_1.AnalyticsTypeEnum.UserAnalytics:
                return this.userAnalytics(type, orders, intervalInfo, showSegments);
            case IAnalytics_1.AnalyticsTypeEnum.TicketsScanned:
                return this.ticketsScanned(type, orders, intervalInfo, showSegments);
            case IAnalytics_1.AnalyticsTypeEnum.UpgradesScanned:
                return this.upgradesScanned(type, orders, intervalInfo, showSegments);
            default:
                return {
                    label: type,
                    interval: interval,
                    intervalOptions: [],
                    coordinates: [{ x: 0, y: 0 }],
                    segments: [],
                    type: IAnalytics_1.AnalyticsValueTypeEnum.Quantity,
                };
        }
    },
    overview(type, orders, intervalInfo) {
        const coordinatesSumFn = (orders) => orders.reduce((cur, order) => {
            let total = 0;
            if (order.type == IOrderType_1.OrderTypeEnum.RSVP) {
                total = sum(order.tickets.map(ticket => Number(ticket === null || ticket === void 0 ? void 0 : ticket.values) || 0)) + sum(order.upgrades.map(upgrade => Number(upgrade === null || upgrade === void 0 ? void 0 : upgrade.price) || 0));
            }
            else {
                total = sum(order.tickets.map(ticket => ticket.price)) + sum(order.upgrades.map(upgrade => upgrade.price));
            }
            return cur + total;
        }, 0);
        // const coordinatesSumFn = (orders: IOrder[]) =>
        //   orders
        //     // .filter(order => order.type === OrderTypeEnum.Paid)
        //     .reduce((cur, order) => cur + sum(order.tickets.map(ticket => ticket.price)) + sum(order.upgrades.map(upgrade => upgrade.price)), 0);
        const coordinates = makeCoordinates(orders, intervalInfo, coordinatesSumFn);
        const { interval, intervalOptions } = intervalInfo;
        let segments = [];
        const coordinatesSumFn2 = (orders) => orders
            // .filter(order => order.type === OrderTypeEnum.Paid)
            .reduce((cur, order) => cur + order.tickets.length, 0);
        const segmentCoordinates = makeCoordinates(orders, intervalInfo, coordinatesSumFn2);
        let segment = {
            label: 'Tickets Sold',
            interval: interval,
            intervalOptions: intervalOptions,
            coordinates: segmentCoordinates,
            segments: [],
            type: IAnalytics_1.AnalyticsValueTypeEnum.Quantity,
        };
        segments.push(segment);
        const coordinatesSumFn3 = (orders) => orders.length; //sum(orders.map(order => { return order.state != OrderStateEnum.Refunded ? 1 : 0} ))
        // .reduce((cur,order) => cur + sum(order.tickets.map(ticket => { return ticket.refund.refunded == false ? 1 : 0})),0)
        // const coordinatesSumFn3 = (orders: IOrder[]) => orders.length;
        const segmentCoordinates2 = makeCoordinates(orders, intervalInfo, coordinatesSumFn3);
        segment = {
            label: 'Orders',
            interval: interval,
            intervalOptions: intervalOptions,
            coordinates: segmentCoordinates2,
            segments: [],
            type: IAnalytics_1.AnalyticsValueTypeEnum.Quantity,
        };
        segments.push(segment);
        const analytics = {
            label: 'Total Sales',
            interval: interval,
            intervalOptions: intervalOptions,
            coordinates,
            segments,
            type: IAnalytics_1.AnalyticsValueTypeEnum.Currency,
        };
        return analytics;
    },
    totalSales(type, orders, intervalInfo, showSegments) {
        const coordinatesSumFn = (orders) => orders.reduce((cur, order) => {
            let total = 0;
            if (order.type == IOrderType_1.OrderTypeEnum.RSVP) {
                total = sum(order.tickets.map(ticket => Number(ticket === null || ticket === void 0 ? void 0 : ticket.values) || 0)) + sum(order.upgrades.map(upgrade => Number(upgrade === null || upgrade === void 0 ? void 0 : upgrade.price) || 0));
            }
            else {
                total = sum(order.tickets.map(ticket => ticket.price)) + sum(order.upgrades.map(upgrade => upgrade.price));
            }
            return cur + total;
        }, 0);
        // const coordinatesSumFn = (orders: IOrder[]) =>
        //   orders
        //     // .filter(order => order.type === OrderTypeEnum.Paid)
        //     .reduce((cur, order) => cur + sum(order.tickets.map(ticket => ticket.price)) + sum(order.upgrades.map(upgrade => upgrade.price)), 0);
        let segmentTypes;
        let segmentCoordinatesHOSumFn;
        // if (showSegments) {
        //   segmentTypes = Object.keys(
        //     orders
        //       .reduce((cur, next: IOrder) => {
        //         return cur.concat(next.tickets);
        //       }, [] as IOrderTicket[])
        //       .reduce((cur, next: IOrderTicket) => {
        //         cur[next.name] = true;
        //         return cur;
        //       }, {})
        //   );
        //   segmentCoordinatesHOSumFn = (segmentType: string) => (orders: IOrder[]) =>
        //     orders
        //       .filter(order => order.type === OrderTypeEnum.Paid)
        //       .reduce((cur, order) => cur + sum(
        //         order.tickets
        //           .filter((ticket) => ticket.name === segmentType)
        //           .map((ticket) => ticket.price)), 0);
        // }
        return makeAnalytics(type, orders, intervalInfo, IAnalytics_1.AnalyticsValueTypeEnum.Currency, coordinatesSumFn, segmentTypes, segmentCoordinatesHOSumFn);
    },
    ticketSales(type, orders, intervalInfo, showSegments) {
        const coordinatesSumFn = (orders) => orders.reduce((cur, order) => {
            let total = 0;
            if (order.type == IOrderType_1.OrderTypeEnum.RSVP) {
                total = sum(order.tickets.map(ticket => Number(ticket === null || ticket === void 0 ? void 0 : ticket.values) || 0)) || 0;
                // total = sum(order.tickets.map(ticket => Number(ticket?.values)|| 0)) + sum(order.upgrades.map(upgrade => Number(upgrade?.price) || 0))
            }
            else {
                total = sum(order.tickets.map(ticket => ticket.price));
            }
            return cur + total;
        }, 0);
        // const coordinatesSumFn = (orders: IOrder[]) =>
        //   orders
        //     // .filter(order => order.type === OrderTypeEnum.Paid)
        //     .reduce((cur, order) => cur + sum(order.tickets.map(ticket => ticket.price)), 0);
        let segmentTypes;
        let segmentCoordinatesHOSumFn;
        if (showSegments) {
            segmentTypes = Object.keys(orders
                .reduce((cur, next) => {
                return cur.concat(next.tickets);
            }, [])
                .reduce((cur, next) => {
                cur[next.name] = true;
                return cur;
            }, {}));
            segmentCoordinatesHOSumFn = (segmentType) => (orders) => {
                //   const ordersData = orders
                //     // .filter(order => order.type === OrderTypeEnum.Paid)
                //     .reduce((cur, order) => cur + sum(
                //       order.tickets
                //         .filter((ticket) => ticket.name === segmentType)
                //         .map((ticket) => ticket.price)), 0);
                //   return ordersData
                // }
                const ordersData = orders.reduce((cur, order) => {
                    let total;
                    if (order.type == IOrderType_1.OrderTypeEnum.RSVP) {
                        total = sum(order.tickets.filter((ticket) => ticket.name === segmentType).map(ticket => Number(ticket === null || ticket === void 0 ? void 0 : ticket.values) || 0));
                    }
                    else {
                        total = sum(order.tickets.filter((ticket) => ticket.name === segmentType).map(ticket => Number(ticket === null || ticket === void 0 ? void 0 : ticket.price) || 0));
                    }
                    return cur + total;
                }, 0);
                return ordersData;
            };
        }
        return makeAnalytics(type, orders, intervalInfo, IAnalytics_1.AnalyticsValueTypeEnum.Currency, coordinatesSumFn, segmentTypes, segmentCoordinatesHOSumFn);
    },
    ticketsSold(type, orders, intervalInfo, showSegments) {
        const coordinatesSumFn = (orders) => orders
            // .filter(order => order.type === OrderTypeEnum.Paid)
            .reduce((cur, order) => cur + order.tickets.length, 0);
        let segmentTypes;
        let segmentCoordinatesHOSumFn;
        if (showSegments) {
            segmentTypes = Object.keys(orders
                .reduce((cur, next) => {
                return cur.concat(next.tickets);
            }, [])
                .reduce((cur, next) => {
                cur[next.name] = true;
                return cur;
            }, {}));
            segmentCoordinatesHOSumFn = (segmentType) => (orders) => orders
                // .filter(order => order.type === OrderTypeEnum.Paid)
                .reduce((cur, order) => cur + order.tickets.filter((ticket) => ticket.name === segmentType).length, 0);
        }
        return makeAnalytics(type, orders, intervalInfo, IAnalytics_1.AnalyticsValueTypeEnum.Quantity, coordinatesSumFn, segmentTypes, segmentCoordinatesHOSumFn);
    },
    ticketsScanned(type, orders, intervalInfo, showSegments) {
        let count = 0;
        const coordinatesSumFn = (orders) => orders.reduce((cur, order) => {
            order === null || order === void 0 ? void 0 : order.tickets.map(ticket => {
                var _a;
                (_a = ticket === null || ticket === void 0 ? void 0 : ticket.scan) === null || _a === void 0 ? void 0 : _a.map(a => {
                    if (a.scanned) {
                        count = count + 1;
                    }
                });
            });
            return count;
        }, 0);
        let segmentTypes;
        let segmentCoordinatesHOSumFn;
        if (showSegments) {
            segmentTypes = Object.keys(orders
                .reduce((cur, next) => {
                return cur.concat(next.tickets);
            }, [])
                .reduce((cur, next) => {
                cur[next.name] = true;
                return cur;
            }, {}));
            segmentCoordinatesHOSumFn = (segmentType) => (orders) => orders
                .reduce((cur, order) => {
                const filteredTickets = order.tickets.filter((ticket) => {
                    return ticket.name === segmentType && (ticket === null || ticket === void 0 ? void 0 : ticket.scan.some(scanData => scanData.scanned === true));
                });
                // console.log(filteredTickets);
                return cur + filteredTickets.length;
            }, 0);
        }
        return makeAnalytics(type, orders, intervalInfo, IAnalytics_1.AnalyticsValueTypeEnum.Quantity, coordinatesSumFn, segmentTypes, segmentCoordinatesHOSumFn);
    },
    // upgradeScannedCount
    upgradesScanned(type, orders, intervalInfo, showSegments) {
        let count = 0;
        const coordinatesSumFn = (orders) => orders.reduce((cur, order) => {
            order === null || order === void 0 ? void 0 : order.upgrades.map(upgrade => {
                if (upgrade === null || upgrade === void 0 ? void 0 : upgrade.scan.scanned) {
                    count = count + 1;
                }
            });
            return count;
        }, 0);
        let segmentTypes;
        let segmentCoordinatesHOSumFn;
        if (showSegments) {
            segmentTypes = Object.keys(orders
                .reduce((cur, next) => {
                return cur.concat(next.upgrades);
            }, [])
                .reduce((cur, next) => {
                cur[next.name] = true;
                return cur;
            }, {}));
            segmentCoordinatesHOSumFn = (segmentType) => (orders) => orders
                .reduce((cur, order) => {
                const filteredUpgrades = order.upgrades.filter((upgrade) => {
                    return upgrade.name === segmentType && (upgrade === null || upgrade === void 0 ? void 0 : upgrade.scan.scanned) === true;
                });
                console.log(filteredUpgrades);
                return cur + filteredUpgrades.length;
            }, 0);
        }
        return makeAnalytics(type, orders, intervalInfo, IAnalytics_1.AnalyticsValueTypeEnum.Quantity, coordinatesSumFn, segmentTypes, segmentCoordinatesHOSumFn);
    },
    ticketComps(type, orders, intervalInfo, showSegments) {
        const coordinatesSumFn = (orders) => orders
            .filter(order => order.type === IOrderType_1.OrderTypeEnum.Complimentary)
            .reduce((cur, order) => cur + order.tickets.length, 0);
        let segmentTypes;
        let segmentCoordinatesHOSumFn;
        if (showSegments) {
            segmentTypes = Object.keys(orders
                .reduce((cur, next) => {
                return cur.concat(next.tickets);
            }, [])
                .reduce((cur, next) => {
                cur[next.name] = true;
                return cur;
            }, {}));
            segmentCoordinatesHOSumFn = (segmentType) => (orders) => orders
                .filter(order => order.type === IOrderType_1.OrderTypeEnum.Complimentary)
                .reduce((cur, order) => cur + order.tickets.filter((ticket) => ticket.name === segmentType).length, 0);
        }
        return makeAnalytics(type, orders, intervalInfo, IAnalytics_1.AnalyticsValueTypeEnum.Quantity, coordinatesSumFn, segmentTypes, segmentCoordinatesHOSumFn);
    },
    upgradeSales(type, orders, intervalInfo, showSegments) {
        const coordinatesSumFn = (orders) => orders
            // .filter(order => order.type === OrderTypeEnum.Paid)
            .reduce((cur, order) => cur + sum(order.upgrades.map(upgrade => upgrade.price)), 0);
        let segmentTypes;
        let segmentCoordinatesHOSumFn;
        if (showSegments) {
            segmentTypes = Object.keys(orders
                .reduce((cur, next) => {
                return cur.concat(next.upgrades);
            }, [])
                .reduce((cur, next) => {
                cur[next.name] = true;
                return cur;
            }, {}));
            segmentCoordinatesHOSumFn = (segmentType) => (orders) => orders
                // .filter(order => order.type === OrderTypeEnum.Paid)
                .reduce((cur, order) => cur + sum(order.upgrades
                .filter((upgrade) => upgrade.name === segmentType)
                .map((upgrade) => upgrade.price)), 0);
        }
        return makeAnalytics(type, orders, intervalInfo, IAnalytics_1.AnalyticsValueTypeEnum.Currency, coordinatesSumFn, segmentTypes, segmentCoordinatesHOSumFn);
    },
    upgradesSold(type, orders, intervalInfo, showSegments) {
        const coordinatesSumFn = (orders) => orders
            // .filter(order => order.type === OrderTypeEnum.Paid)
            .reduce((cur, order) => cur + order.upgrades.length, 0);
        let segmentTypes;
        let segmentCoordinatesHOSumFn;
        if (showSegments) {
            segmentTypes = Object.keys(orders
                .reduce((cur, next) => {
                return cur.concat(next.upgrades);
            }, [])
                .reduce((cur, next) => {
                cur[next.name] = true;
                return cur;
            }, {}));
            segmentCoordinatesHOSumFn = (segmentType) => (orders) => orders
                // .filter(order => order.type === OrderTypeEnum.Paid)
                .reduce((cur, order) => cur + order.upgrades.filter((upgrade) => upgrade.name === segmentType).length, 0);
        }
        return makeAnalytics(type, orders, intervalInfo, IAnalytics_1.AnalyticsValueTypeEnum.Quantity, coordinatesSumFn, segmentTypes, segmentCoordinatesHOSumFn);
    },
    upgradeComps(type, orders, intervalInfo, showSegments) {
        const coordinatesSumFn = (orders) => orders.reduce((cur, order) => {
            let total = 0;
            if (order.type == IOrderType_1.OrderTypeEnum.RSVP) {
                total = sum(order.upgrades.map(upgrade => Number(upgrade === null || upgrade === void 0 ? void 0 : upgrade.price) || 0));
                // total = sum(order.tickets.map(ticket => Number(ticket?.values)|| 0)) + sum(order.upgrades.map(upgrade => Number(upgrade?.price) || 0))
            }
            else {
                total = sum(order.upgrades.map(upgrade => upgrade.price));
                // total = sum(order.tickets.map(ticket => ticket.price)) + sum(order.upgrades.map(upgrade => upgrade.price))
            }
            return cur + total;
        }, 0);
        // const coordinatesSumFn = (orders: IOrder[]) =>
        //   orders
        //     .reduce((cur, order) =>
        //       cur + order.upgrades.filter(upgrade => upgrade.price === 0).length,
        //       0);
        let segmentTypes;
        let segmentCoordinatesHOSumFn;
        if (showSegments) {
            segmentTypes = Object.keys(orders
                .reduce((cur, next) => {
                return cur.concat(next.tickets);
            }, [])
                .reduce((cur, next) => {
                cur[next.name] = true;
                return cur;
            }, {}));
            segmentCoordinatesHOSumFn = (segmentType) => (orders) => orders
                .reduce((cur, order) => cur + order.upgrades.filter((upgrade) => upgrade.name === segmentType && upgrade.price === 0).length, 0);
        }
        return makeAnalytics(type, orders, intervalInfo, IAnalytics_1.AnalyticsValueTypeEnum.Quantity, coordinatesSumFn, segmentTypes, segmentCoordinatesHOSumFn);
    },
    promotions(type, orders, intervalInfo, showSegments) {
        const coordinatesSumFn = (orders) => orders.filter(order => Boolean(order.promotionCode))
            .length;
        let segmentTypes;
        let segmentCoordinatesHOSumFn;
        if (showSegments) {
            segmentTypes = Object.keys(orders.reduce((cur, next) => {
                if (next.promotionCode)
                    cur[next.promotionCode] = true;
                return cur;
            }, {}));
            segmentCoordinatesHOSumFn = (segmentType) => (orders) => orders
                .filter(order => order.promotionCode === segmentType)
                .length;
        }
        return makeAnalytics(type, orders, intervalInfo, IAnalytics_1.AnalyticsValueTypeEnum.Quantity, coordinatesSumFn, segmentTypes, segmentCoordinatesHOSumFn);
    },
    totalOrders(type, orders, intervalInfo) {
        const coordinatesSumFn = (orders) => orders.length;
        return makeAnalytics(type, orders, intervalInfo, IAnalytics_1.AnalyticsValueTypeEnum.Quantity, coordinatesSumFn);
    },
    eventAnalytics(type, orders, intervalInfo, showSegments) {
        const coordinatesSumFn = (orders) => orders.filter(order => Boolean(order.promotionCode))
            .length;
        let segmentTypes;
        let segmentCoordinatesHOSumFn;
        if (showSegments) {
            segmentTypes = [IAnalytics_1.EventAnalyticsEnum.SoldOutPercentage, IAnalytics_1.EventAnalyticsEnum.TotalSales];
            segmentCoordinatesHOSumFn = (segmentType) => (orders) => {
                switch (segmentType) {
                    case IAnalytics_1.EventAnalyticsEnum.SoldOutPercentage:
                        return 0;
                    case IAnalytics_1.EventAnalyticsEnum.TotalSales:
                        return calculateTotalSale(orders);
                    // orders.reduce((cur: number, next: IOrder) => cur + next?.payments?.[0]?.transferAmount ?? 0, 0)
                }
            };
        }
        const calculateTotalSale = (orders) => orders
            .reduce((cur, order) => {
            let total = 0;
            if (order.type == IOrderType_1.OrderTypeEnum.RSVP) {
                total = sum(order.tickets.map(ticket => Number(ticket === null || ticket === void 0 ? void 0 : ticket.values) || 0)) + sum(order.upgrades.map(upgrade => Number(upgrade === null || upgrade === void 0 ? void 0 : upgrade.price) || 0));
            }
            else {
                total = sum(order.tickets.map(ticket => ticket.price)) + sum(order.upgrades.map(upgrade => upgrade.price));
            }
            return cur + total;
        }, 0);
        const data = makeAnalytics(type, orders, intervalInfo, IAnalytics_1.AnalyticsValueTypeEnum.Quantity, coordinatesSumFn, segmentTypes, segmentCoordinatesHOSumFn);
        return data;
    },
    userAnalytics(type, orders, intervalInfo, showSegments) {
        const coordinatesSumFn = (orders) => orders.filter(order => Boolean(order.promotionCode))
            .length;
        let segmentTypes;
        let segmentCoordinatesHOSumFn;
        if (showSegments) {
            segmentTypes = [
                IAnalytics_1.UserAnalyticsEnum.EventsAttendedCount,
                IAnalytics_1.UserAnalyticsEnum.TicketsPurchasedCount,
                IAnalytics_1.UserAnalyticsEnum.LifeTimeValue
            ];
            segmentCoordinatesHOSumFn = (segmentType) => (orders) => {
                switch (segmentType) {
                    case IAnalytics_1.UserAnalyticsEnum.EventsAttendedCount:
                        return [...new Set(orders.map(order => order.eventId))].length;
                    case IAnalytics_1.UserAnalyticsEnum.TicketsPurchasedCount:
                        return orders.reduce((cur, next) => { var _a; return (_a = cur + next.tickets.length) !== null && _a !== void 0 ? _a : 0; }, 0);
                    case IAnalytics_1.UserAnalyticsEnum.LifeTimeValue:
                        return orders.reduce((cur, next) => { var _a, _b, _c; return (_c = cur + ((_b = (_a = next.payments) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.transferAmount)) !== null && _c !== void 0 ? _c : 0; }, 0);
                }
            };
        }
        return makeAnalytics(type, orders, intervalInfo, IAnalytics_1.AnalyticsValueTypeEnum.Quantity, coordinatesSumFn, segmentTypes, segmentCoordinatesHOSumFn);
    },
    // Returns start and end date
    durationToUnix(duration, timezone) {
        const durations = {
            [IAnalytics_1.AnalyticsDurationEnum.AllTime]: () => {
                const duration = {
                    startsAt: 0,
                    endsAt: 0,
                };
                return duration;
            },
            [IAnalytics_1.AnalyticsDurationEnum.Today]: () => {
                const duration = {
                    startsAt: timezone ? moment.tz(timezone).startOf("day").unix() : Time.getStartOfCurrentDay(),
                    endsAt: timezone ? moment.tz(timezone).endOf("day").unix() : Time.getEndOfCurrentDay()
                };
                return duration;
            },
            [IAnalytics_1.AnalyticsDurationEnum.OneWeek]: () => {
                const duration = {
                    startsAt: Time.now() - Time.DAY * 7,
                    endsAt: Time.now(),
                };
                return duration;
            },
            [IAnalytics_1.AnalyticsDurationEnum.OneMonth]: () => {
                const duration = {
                    startsAt: Time.now() - Time.DAY * 30,
                    endsAt: Time.now(),
                };
                return duration;
            },
            [IAnalytics_1.AnalyticsDurationEnum.MonthToDate]: () => {
                const duration = {
                    startsAt: Time.getStartOfCurrentMonth(),
                    endsAt: Time.now(),
                };
                return duration;
            },
            [IAnalytics_1.AnalyticsDurationEnum.YearToDate]: () => {
                const duration = {
                    startsAt: Time.getStartOfCurrentYear(),
                    endsAt: Time.now(),
                };
                return duration;
            },
            [IAnalytics_1.AnalyticsDurationEnum.OneYear]: () => {
                const duration = {
                    startsAt: Time.now() - Time.DAY * 365,
                    endsAt: Time.now(),
                };
                return duration;
            },
            [IAnalytics_1.AnalyticsDurationEnum.Custom]: () => {
                const duration = {
                    startsAt: 0,
                    endsAt: 0,
                };
                return duration;
            },
        };
        return durations[duration]();
    },
    // Returns available intervals
    durationIntervals(interval) {
        const intervals = {
            [IAnalytics_1.AnalyticsDurationEnum.AllTime]: () => {
                return [];
            },
            [IAnalytics_1.AnalyticsDurationEnum.Today]: () => {
                return [IAnalytics_1.AnalyticsIntervalEnum.Hour];
            },
            [IAnalytics_1.AnalyticsDurationEnum.OneWeek]: () => {
                return [IAnalytics_1.AnalyticsIntervalEnum.Day];
            },
            [IAnalytics_1.AnalyticsDurationEnum.OneMonth]: () => {
                return [IAnalytics_1.AnalyticsIntervalEnum.Day, IAnalytics_1.AnalyticsIntervalEnum.Week];
            },
            [IAnalytics_1.AnalyticsDurationEnum.MonthToDate]: () => {
                return [IAnalytics_1.AnalyticsIntervalEnum.Day, IAnalytics_1.AnalyticsIntervalEnum.Week];
            },
            [IAnalytics_1.AnalyticsDurationEnum.YearToDate]: () => {
                return [IAnalytics_1.AnalyticsIntervalEnum.Week, IAnalytics_1.AnalyticsIntervalEnum.Month];
            },
            [IAnalytics_1.AnalyticsDurationEnum.OneYear]: () => {
                return [IAnalytics_1.AnalyticsIntervalEnum.Week, IAnalytics_1.AnalyticsIntervalEnum.Month];
            },
            [IAnalytics_1.AnalyticsDurationEnum.Custom]: () => {
                return [];
            },
        };
        return intervals[interval]();
    },
    getDateFormat(time, interval, timezone = 'America/Denver') {
        switch (interval) {
            case IAnalytics_1.AnalyticsIntervalEnum.Hour:
                return Time.format(time, 'h:mma', timezone);
            case IAnalytics_1.AnalyticsIntervalEnum.Day:
                return Time.format(time, 'MMM DD', timezone);
            case IAnalytics_1.AnalyticsIntervalEnum.Week:
                return `${Time.format(time, 'MMM DD', timezone)} - ${Time.format(time + (Time.DAY * 7), 'MMM DD', timezone)}`;
            case IAnalytics_1.AnalyticsIntervalEnum.Month:
                return Time.format(time, 'MMM YYYY', timezone);
            case IAnalytics_1.AnalyticsIntervalEnum.Year:
                return Time.format(time, 'YYYY', timezone);
            default:
                return Time.format(time, 'MMM DD', timezone);
        }
    },
    getTotalValue(coords) {
        if (!coords) {
            return 0;
        }
        return coords.reduce((acc, next) => {
            return acc += next.y;
        }, 0);
    },
    getDisplayMetric(data, hoverIndex) {
        let val = 0;
        if (data.coordinates) {
            if (hoverIndex === undefined) {
                val = this.getTotalValue(data.coordinates);
            }
            else {
                let coord = data === null || data === void 0 ? void 0 : data.coordinates.find((coord) => coord.x === hoverIndex);
                if (coord)
                    val = coord.y;
            }
        }
        if (data.type === IAnalytics_1.AnalyticsValueTypeEnum.Currency) {
            return `$${Price.output(val, true)}`;
        }
        return val === null || val === void 0 ? void 0 : val.toString();
    },
    getMaxXVal(dataArray) {
        return dataArray.reduce((max, p) => p.x > max ? p.x : max, 0);
    },
    getMinXVal(dataArray) {
        return dataArray.reduce((min, p) => p.x < min ? p.x : min, Infinity);
    },
    getMaxYVal(dataArray) {
        return dataArray.reduce((max, p) => p.y > max ? p.y : max, 0);
    }
};
//# sourceMappingURL=AnalyticsUtil.js.map